module.exports = __webpack_public_path__ + "static/media/check-circle.333eaa54.svg";